/**
 * Nutrient Table Renderer
 *
 * Handles three data formats found in the metafield:
 *   1. Markdown pipe tables  → parsed into <table>
 *   2. Existing HTML         → passed through as-is
 *   3. Plain text            → rendered as <p> elements
 *
 * Auto-initialises on DOMContentLoaded and on accordion toggle.
 */
(function () {
  'use strict';

  /* ── Markdown table helpers ── */

  function isSeparatorRow(line) {
    var inner = line.replace(/^\|/, '').replace(/\|$/, '');
    var cells = inner.split('|');
    if (cells.length < 1) return false;
    return cells.every(function (c) {
      return /^\s*:?-{2,}:?\s*$/.test(c);
    });
  }

  function parseCells(line) {
    var trimmed = line.trim();
    if (trimmed.charAt(0) === '|') trimmed = trimmed.substring(1);
    if (trimmed.charAt(trimmed.length - 1) === '|')
      trimmed = trimmed.substring(0, trimmed.length - 1);
    return trimmed.split('|').map(function (c) { return c.trim(); });
  }

  function isTableRow(line) {
    var s = line.trim();
    return s.length > 2 && s.charAt(0) === '|' && s.lastIndexOf('|') > 0;
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function buildTable(tableLines) {
    var dataRows = [];
    for (var i = 0; i < tableLines.length; i++) {
      if (!isSeparatorRow(tableLines[i])) {
        dataRows.push(parseCells(tableLines[i]));
      }
    }
    if (dataRows.length === 0) return '';

    // Determine the consistent column count from header
    var colCount = dataRows[0].length;

    var html = '<table class="nutrient-tbl">';

    // Header
    html += '<thead><tr>';
    for (var h = 0; h < colCount; h++) {
      html += '<th>' + escapeHtml(dataRows[0][h] || '') + '</th>';
    }
    html += '</tr></thead>';

    // Body
    if (dataRows.length > 1) {
      html += '<tbody>';
      for (var r = 1; r < dataRows.length; r++) {
        html += '<tr>';
        for (var c = 0; c < colCount; c++) {
          var val = (c < dataRows[r].length) ? dataRows[r][c] : '';
          html += '<td>' + escapeHtml(val) + '</td>';
        }
        html += '</tr>';
      }
      html += '</tbody>';
    }

    html += '</table>';
    return html;
  }

  /* ── Format detection ── */

  function containsHtml(str) {
    // Detect if the raw content is already HTML
    return /<\s*(table|div|p|span|strong|br)\b/i.test(str);
  }

  /* ── Rendering ── */

  function renderMarkdown(raw) {
    // Unescape markdown \*
    raw = raw.replace(/\\\*/g, '*');

    var lines = raw.split('\n');
    var htmlParts = [];
    var i = 0;

    while (i < lines.length) {
      if (isTableRow(lines[i])) {
        var tableLines = [];
        while (i < lines.length && isTableRow(lines[i])) {
          tableLines.push(lines[i]);
          i++;
        }
        htmlParts.push(buildTable(tableLines));
      } else {
        var text = lines[i].trim();
        if (text.length > 0) {
          htmlParts.push('<p>' + escapeHtml(text) + '</p>');
        }
        i++;
      }
    }

    return htmlParts.join('');
  }

  function renderHtmlContent(raw) {
    // Content is already HTML — add our table class for styling
    // Replace existing <table...> with our class added
    return raw.replace(/<table\b([^>]*)>/gi, function (match, attrs) {
      if (/class\s*=/.test(attrs)) {
        // Append our class
        return match.replace(/class\s*=\s*["']([^"']*)["']/, 'class="$1 nutrient-tbl"');
      }
      return '<table class="nutrient-tbl"' + attrs + '>';
    });
  }

  function renderNutrientBlock(el) {
    // Read raw content — either from textContent (escaped in Liquid)
    // or innerHTML (if HTML was stored directly)
    var rawHtml = el.innerHTML || '';
    var rawText = el.textContent || el.innerText || '';

    var output;

    if (containsHtml(rawHtml)) {
      // Already HTML — pass through with our class added
      output = renderHtmlContent(rawHtml);
    } else {
      // Markdown / plain text — parse it
      output = renderMarkdown(rawText);
    }

    el.innerHTML = output;
    el.removeAttribute('data-nutrient-raw');
    el.setAttribute('data-nutrient-rendered', '');
  }

  function initAll() {
    var blocks = document.querySelectorAll('[data-nutrient-raw]');
    for (var i = 0; i < blocks.length; i++) {
      renderNutrientBlock(blocks[i]);
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Also run when an accordion opens (handles lazy rendering)
  document.addEventListener('toggle', function (e) {
    if (e.target.tagName === 'DETAILS' && e.target.open) {
      var inner = e.target.querySelectorAll('[data-nutrient-raw]');
      for (var j = 0; j < inner.length; j++) {
        renderNutrientBlock(inner[j]);
      }
    }
  }, true);
})();